import React, { useState, useEffect } from 'react';
import { Plus } from 'lucide-react';
import AddActivityPage from '../../pages/AddActivityPage';
import { Cross } from '../Icons/CustomIcons';
import CloseModalButton from '../Common/CloseModalButton';
import { RoundButtonS } from '../Common/Button';

const AddActivityDrawer = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    document.body.classList.toggle('drawer-open', isOpen);
    return () => document.body.classList.remove('drawer-open');
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <div
          className="drawer-overlay"
          role="dialog"
          aria-modal="true"
          aria-label="Aktivität erstellen"
          onClick={() => setIsOpen(false)}
        >
          <div
            className="drawer-panel"
            onClick={(e) => e.stopPropagation()}
          >            
            <CloseModalButton
              className="drawer-close"
              onClick={() => setIsOpen(false)}
              ariaLabel="Schliessen"
            >
              <Cross size={20} />
            </CloseModalButton>
            
            <AddActivityPage onClose={() => setIsOpen(false)} />
          </div>
        </div>
      )}

      <RoundButtonS
        className="btn-primary fab-add-activity"
        onClick={() => setIsOpen(true)}
        title="Aktivität mitteilen"
      >
        <Plus size={28} />
      </RoundButtonS>
    </>
  );
};

export default AddActivityDrawer;
